<template>
  <div class="sn-page sn-f-col-b-c" id="app">
    <!-- 无需功能框架路由 -->
    <template v-if="unFrame">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
    <template v-else>
      <div class="sn-f-col-c-c app-top">
        <app-header></app-header>
        <app-logo></app-logo>
        <app-func></app-func>
      </div>
      <div class="sn-f-1 app-frame">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <app-float></app-float>
      <app-footer></app-footer>
    </template>
    <loading v-if="$sn.vuex.get('vuex_loading')"></loading>
    <toast v-if="$sn.vuex.get('vuex_toast.type')"></toast>
    <modal v-if="$sn.vuex.get('vuex_modal.type')"></modal>
  </div>
</template>
<script type="text/javascript">
import { UnFrameConfig } from '@/common/utils/login-config';
import Theme from '@/common/style/theme';

export default {
  components: {
    'app-header': () => import('@/components/app/header'),
    'app-logo': () => import('@/components/app/logo'),
    'app-float': () => import('@/components/app/float'),
    'app-func': () => import('@/components/app/func'),
    'app-footer': () => import('@/components/app/footer'),
    'loading': () => import('@/components/assembly/loading'),
    'toast': () => import('@/components/assembly/toast'),
    'modal': () => import('@/components/assembly/modal')
  },
  computed: {
    // 大屏排班展示版
    unFrame() {
      return UnFrameConfig.includes(this.$route.path);
    }
  },
  created: function() {
    this.global_changeTheme();
  },
  methods: {
    global_changeTheme() {
      // 默认值：通用主题色
      const theme = Theme.ordinary;
      // 与当前医院主题色对照表进行匹配
      if (!this.$sn.validate.empty(Theme[this.$sn.utils.getHospitalId()])) {
        const special = Theme[this.$sn.utils.getHospitalId()];
        Object.keys(special).forEach(key => {
          theme[key] = special[key];
        });
      }
      this.$nextTick(() => {
        const app = document.getElementById('sn');
        if (app) {
          Object.keys(theme).forEach(key => {
            // 向 app 上挂载各主题色变量
            app.style.setProperty('--' + key, theme[key]);
            // 将主题色挂载至 $sn.color
            this.$set(this.$sn.color, key, theme[key]);
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import "@/common/style/integration";

#app {
  .app-top {
    width: 100%;
  }

  .app-frame {
    overflow: hidden;
    width: 1280px;
    background-color: $white;
  }
}
</style>
